import React from "react";

import { FormDialog } from "../../../../../../../../components/dialogs/FormDialog/FormDialog";

import Form from "./Form";

export const SAVE_LINK_INITIAL_VALUES = {
    isRequired: true,
    prependDomainNameNormalizer: true,
    removeGetParametersNormalizer: true
};

const SaveLinksDialog = ({ initialValues, ...restProps }) => (
    <FormDialog
        title="Save links with name"
        initialValues={initialValues}
        layout="default"
        {...restProps}
        form={(<Form />)}
    />
);

export default SaveLinksDialog;
